import { useParams } from 'react-router-dom'

import { usePermissionTemplateGetApi } from '@/common/api/modules/permissionTemplate'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import PermissionTemplateEditPage from '@/components/container/page/site/setting/permission/PermissionTemplateEditPage'

const PermissionTemplateUpdatePage = () => {
  const siteId = useSiteId()
  const { permissionId } = useParams()

  const { data, error, mutate } = usePermissionTemplateGetApi({
    site_id: siteId,
    template_id: Number(permissionId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <PermissionTemplateEditPage template={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default PermissionTemplateUpdatePage
